"use client";

import { useState } from "react";

import { Button } from "@/components/buttons/Button";
import { logError } from "@/utils/logError";

export function CancelButtons({
  positiveText,
  negativeText,
  onPositive,
  onNegative,
}: {
  positiveText: string;
  onPositive: () => void;
} & (
  | { negativeText: string; onNegative: () => void | Promise<void> }
  | { negativeText: null; onNegative: null }
)) {
  const [isLoading, setIsLoading] = useState(false);

  const handleNegative = async () => {
    if (onNegative !== null) {
      try {
        setIsLoading(true);
        await onNegative();
      } catch (error) {
        logError(error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <div className="flex w-full justify-between gap-x-4">
      <Button onClick={onPositive} className="w-full">
        {positiveText}
      </Button>

      {/* If negativeText is not null then so aren't onNegative */}
      {negativeText !== null && (
        <Button
          onClick={handleNegative}
          className="w-full"
          variant="error"
          loading={isLoading}
        >
          {negativeText}
        </Button>
      )}
    </div>
  );
}
